import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import FormField from "./FormField";

function renderOption(o) {
  return (
    <option key={o.value} value={o.value}>
      {o.text}
    </option>
  );
}

function Select({
  field,
  options,
  prompt = "(Select one)",
  disabled = false,
  multiple = false
}) {
  const blank = prompt && <option value="">{prompt}</option>;

  return (
    <select
      className="form-control"
      {...field}
      disabled={disabled}
      multiple={multiple}
    >
      {blank}
      {options.map(renderOption)}
    </select>
  );
}

export default function FormSelect({
  label,
  name,
  options,
  disabled = false,
  inputProps = {}
}) {
  return (
    <Field name={name} {...inputProps}>
      {({ field, ...childProps }) => (
        <FormField
          {...childProps}
          field={Object.assign(field, inputProps.field || {})}
          label={label}
        >
          <Select
            field={field}
            {...childProps}
            options={options}
            value={field.value}
            disabled={disabled}
          />
        </FormField>
      )}
    </Field>
  );
}

Select.propTypes = {
  input: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
    })
  ).isRequired,
  prompt: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  multiple: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormikFormInput/Select.jsx